import { Link } from "react-router-dom";
import { HARDCODED_SERVICE_PATHS, serviceMatchesRoute } from "../../utils/serviceRouteMap";
import { getAccountMenuItems } from "./accountMenuItems";

export const getMenuItems = (
  user,
  appConfig = {},
  allowedServices,
  t,
  hasAssignedProjects = false,
  allServices,
) => {
  const translate = (key, fallback) =>
    typeof t === "function" ? t(key) : fallback;

  const hasPathAccess = (path) => {
    if (!user) return false;
    if (user.role === "sysAdmin" || user.role === "admin") return true;
    if (!Array.isArray(allowedServices)) return false;

    // Same rule as the routes (path or service_type), so menu and access agree.
    return allowedServices.some((service) => serviceMatchesRoute(service, path));
  };

  const items = [
    //   {
    //   key: "home",
    // label: <Link to="/">{translate("common.menu.home", "Home")}</Link>,
    //},
  ];

  if (user) {
    // items.push({
    //   key: "services",
    //   label: <Link to="/data-services">Services Catalog</Link>,
    // });
    const dataChildren = [
      {
        key: "/data-catalog",
        label: (
          <Link to="/data-catalog">
            {translate("common.menu.dataCatalog", "Data Catalog")}
          </Link>
        ),
      },
      {
        key: "/discover-data",
        label: (
          <Link to="/discover-data">
            {translate("common.menu.dataDiscovery", "Data Discovery")}
          </Link>
        ),
      },
      {
        key: "/data-stewardship",
        label: (
          <Link to="/data-stewardship">
            {translate("common.menu.dataStewardship", "Data Stewardship")}
          </Link>
        ),
      },
      {
        key: "/donate-dataset",
        label: (
          <Link to="/donate-dataset">
            {translate("common.menu.dataDonation", "Data Donation")}
          </Link>
        ),
      },
    ].filter((item) => hasPathAccess(item.key));

    // HPC Flows is its own service, assigned to projects by an admin.
    if (hasPathAccess("/hpc-flows")) {
      dataChildren.push({
        key: "/hpc-flows",
        label: (
          <Link to="/hpc-flows">
            {translate("common.menu.hpcFlows", "HPC Flows")}
          </Link>
        ),
      });
    }

    // Hide Data parent when user has no permitted data links.
    if (dataChildren.length > 0) {
      items.push({
        key: "data",
        label: translate("common.menu.data", "Data"),
        children: dataChildren,
      });
    }

    if (hasPathAccess("/software-catalog")) {
      items.push({
        key: "software",
        label: "Software",
        children: [
          { key: "software-catalog", label: <Link to="/software-catalog">Software Catalog</Link> },
        ],
      });
    }

    if (hasPathAccess("/model-catalog")) {
      items.push({
        key: "models",
        label: translate("common.menu.models", "Models"),
        children: [
          {
            key: "model-catalog",
            label: (
              <Link to="/model-catalog">
                {translate("common.menu.modelCatalog", "Model Catalog")}
              </Link>
            ),
          },
        ],
      });
    }

    const infrastructureChildren = [
      {
        key: "/staging-ticket",
        label: (
          <Link to="/staging-ticket">
            {translate("common.menu.stagingTicket", "Staging Ticket")}
          </Link>
        ),
      },
    ].filter((item) => hasPathAccess(item.key));

    if (infrastructureChildren.length > 0) {
      items.push({
        key: "infrastructure",
        label: translate("common.menu.infrastructure", "Infrastructure"),
        children: infrastructureChildren,
      });
    }

    const isAdmin = user.role === "sysAdmin" || user.role === "admin";
    const services = isAdmin ? allServices || [] : allowedServices || [];

    const dynamicServiceItems = services
      .filter((s) => s.path && !HARDCODED_SERVICE_PATHS.has(s.path))
      .map((s) => ({
        key: s.path,
        label: s.path.startsWith("http") ? (
          <a href={s.path} target="_blank" rel="noopener noreferrer">
            {s.name || s.path}
          </a>
        ) : (
          <Link to={s.path}>{s.name || s.path}</Link>
        ),
      }));

    if (dynamicServiceItems.length > 0) {
      items.push({
        key: "services",
        label: translate("common.menu.services", "Services"),
        children: dynamicServiceItems,
      });
    }
  }
  // In stable mode, hide all secure menu items (projects, admin)
  if (appConfig.isStableMode) {
    return items;
  }

  items.push(...getAccountMenuItems(user, translate, hasAssignedProjects));

  return items;
};
